import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  REQUERIMIENTOS_LISTA,
  REQUERIMIENTOS_NUEVOACTUALIZAR,
  REQUERIMIENTOS_EVALUACION
} from 'constants/codigosTransacciones'

import EvaluacionPage from './evaluacion'
import ListaPage from './lista'
import NuevoActualizarPage from './nuevo-actualizar'

export default function RequerimientosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${REQUERIMIENTOS_EVALUACION}`} component={EvaluacionPage} />
        <Route path={`/${REQUERIMIENTOS_NUEVOACTUALIZAR}/:id`} component={NuevoActualizarPage} />
        <Route path={`/${REQUERIMIENTOS_NUEVOACTUALIZAR}`} component={NuevoActualizarPage} />
        <Route path={`/${REQUERIMIENTOS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
